
import { Results } from "./Results";
import { OrganizationDetails, Answer } from "@/types/assessment";

interface ResultsStepProps {
  maturityLevel: string;
  overallScore: number;
  description: string;
  dimensionScores: Record<string, number>;
  organizationDetails: OrganizationDetails;
  answers: Answer[];
  onStartNew: () => void;
  onSave: () => void;
  isSaving: boolean;
  savedAssessmentId: string | null;
  assessmentId: string;
}

export const ResultsStep = ({
  maturityLevel,
  overallScore,
  description,
  dimensionScores,
  organizationDetails,
  answers,
  onStartNew,
  onSave,
  isSaving,
  savedAssessmentId,
  assessmentId,
}: ResultsStepProps) => {
  return (
    <div className="w-full max-w-5xl mx-auto">
      <Results
        maturityLevel={maturityLevel}
        overallScore={overallScore}
        description={description}
        dimensionScores={dimensionScores}
        organizationDetails={organizationDetails}
        answers={answers}
        onStartNew={onStartNew}
        onSave={onSave}
        isSaving={isSaving}
        savedAssessmentId={savedAssessmentId}
        assessmentId={assessmentId}
        isViewMode={false}
      />
    </div>
  );
};
